import "intersection-observer";
import Swiper from "swiper";
import firstViewAnimation from "./modules/firstViewAnimation";
import MatchHeight from "matchheight";
import $ from "jquery";
import SmoothScroll from "smooth-scroll";
import { _sessionStorage } from "./modules/_sessionStorage";
import topNavDisplayAnimetion from "./modules/animation/topNavDisplayAnimetion";
import scrollButtonDisplayAnimation from "./modules/animation/scrollButtonDisplayAnimation";


$(function() {
  $(".recruitPageFaq h5").click(function() {
    $(this)
      .next(".recruitPageFaq__answer")
      .slideToggle(10);
    $(this).toggleClass("open");
  })
});

new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true
});

new Swiper(".greetingVoice .swiper-container", {
  loop: true,
  effect: "slide",
  slidesPerView: 1,
  spaceBetween: 20,
  watchOverflow: true,
  speed: 500,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.voice-swiper-button-next',
    prevEl: '.voice-swiper-button-prev',
  },
  breakpoints: {
    770: {
      slidesPerView: 1,
      spaceBetween: 2,
    },
  }
});

$(function() {
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $('.spMenu').addClass('fix');
      $('.footerFixarea').addClass('fix');
    } else {
      $('.spMenu').removeClass('fix');
      $('.footerFixarea').removeClass('fix');
    }
  });
});

$(function(){
  $(".spMenu__ttl").click(function(){
    $(".spMenu ul").toggleClass("open");
    $(".spMenu__ttl__icn__box").toggleClass("open");
  });
});

MatchHeight.init();

$(function(){
  $.ajax({
    type: 'GET',
    url: 'https://graph.facebook.com/v3.0/17841413984493049?fields=name%2Cmedia.limit(6)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=EAAGX5AaaOVcBAJgsz4ZA9OnHpmcvoMXG4JMqabv9ZAu92pFR2e3UL2wg5sk0dhEEs8XhI1bwgICRH4EMH9wocV7BSU8RBjcwirl5QwX2hmvsYv2ySr0uzdQnmpC7leXRyWZAwiAjKAquhya2NuhvasZA4amtrFtQ0WUmva74IZBDAKWp6rEwc',
    dataType: 'json',
    success: function(json) {
      var html = '';
      var insta = json.media.data;
      for (var i = 0; i < insta.length; i++) {
        html += '<ul><li><a class="over" href="' + insta[i].permalink + '" target="_blank"><img src="' + insta[i].media_url + '"></a></li></ul';
      }
      $("#instafeed").append(html);
    },
    error: function() {
      //エラー時の処理
    }
  });
});

const STORAGE_KEY = "segawa_fv";
const CURRENT_STORAGE_VALUE = _sessionStorage.fetch(STORAGE_KEY);

if (document.querySelector(".buttonScrollDown")) {
  scrollButtonDisplayAnimation(CURRENT_STORAGE_VALUE);
}

if (document.getElementById("top")) {
  topNavDisplayAnimetion();
}

if (CURRENT_STORAGE_VALUE === null) {
  firstViewAnimation();
  _sessionStorage.save(`${STORAGE_KEY}`, 'true');
}
